import { Link, useNavigate, useLocation } from "react-router-dom";
import { auth } from "@/lib/api";

export default function Navbar() {
  const nav = useNavigate();
  const loc = useLocation();
  const u = auth.user();
  const isAuthed = !!auth.token();

  const link = (to, label, testid) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`px-3 py-1 text-sm border ${active ? "bg-black text-white border-black" : "border-transparent hover:border-black"} transition-colors`}
      >
        {label}
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-40 glass border-b border-black/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-[#E53935] flex items-center justify-center text-white font-display text-lg">F</div>
          <span className="font-display text-xl tracking-tighter">FaceMatch</span>
        </Link>
        <nav className="flex items-center gap-1">
          {isAuthed ? (
            <>
              {link("/discover", "Rate", "nav-discover")}
              {link("/matches", "Matches", "nav-matches")}
              {link("/profile", "Profile", "nav-profile")}
              <button
                data-testid="nav-logout"
                onClick={() => { auth.clear(); nav("/"); }}
                className="ml-2 px-3 py-1 text-sm border border-black hover:bg-black hover:text-white transition-colors"
              >
                Logout
              </button>
              {u?.ai_rating != null && (
                <div className="ml-3 px-2 py-1 bg-black text-white font-mono text-xs" data-testid="nav-rating">
                  {u.ai_rating?.toFixed(1)}/10
                </div>
              )}
            </>
          ) : (
            <>
              {link("/login", "Login", "nav-login")}
              <Link to="/signup" data-testid="nav-signup" className="ml-2 px-4 py-2 bg-[#E53935] text-white text-sm hover:bg-[#C62828]">
                Join
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
